<template>
  <div class="graphic-one-updown"
       :class="{'graphic-item-padding': isPadding}"
       :style="itemStyle"
  >
    <div class="left-pic" v-if="specialData.includeItemsImageOrVideo" :style="imgStyle">
      <img ref="picture" v-if="item.entryImg" :alt="item.titleName" class="picture" :style="imgStyle" />
      <img :src="defaultImg" v-else :alt="item.titleName" class="picture default-picture" :style="imgStyle" />
      <img class="play-btn" v-if="item.fileType == 2 || item.selectType == 2" :src="playBtn" alt="">
    </div>
    <div class="right-cont" v-if="(specialData.includeItemsDes&&item.titleDes)||(specialData.includeItemsTitle&&item.titleName)" :class="{'is-pad': specialStyle.oneGroupBorder || specialStyle.oneGroupBorderShadow}">
      <h2 class="graphic-title" :style="titleStyle" v-if="specialData.includeItemsTitle">{{item.titleName}}</h2>
      <p class="summary" :style="summaryStyle" v-if="specialData.includeItemsDes">{{item.titleDes}}</p>

      <div class="create-time" v-if="specialData.showContentType == 2 && specialData.showPublishFlag">
        {{publishItem}}</div>

      <div v-if="specialData.showContentType == 2 && specialData.showReadFlag" class="bottomV">
        <img
          class="seeNum"
          src="https://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/04/1619767042239.png"
          alt=""
        />{{ item.readNum }}
      </div>


      <!--      <p class="create-time" v-if="specialData.showContentType == 2 && specialData.showPublishFlag && (specialData.showRows == 1 || !specialData.includeItemsImageOrVideo)">{{item.publishItem}}</p>-->
      <!-- dddddddddddd -->
    </div>
  </div>
</template>
<script>
import playBtn from '../../asset/images/play-btn.png'
import { changeImgSizeFn } from './resizeImg'
export default {
  data() {
    const { tempData: { specialData, specialStyle, specialEntryList }, terminal } = this.data
    return {
      playBtn,
      specialData,
      specialStyle,
      specialEntryList,
      terminal,
      pictureUrl: '',
      publishItem:''
    }
  },
  props: {
    data: {
      type: Object
    },
    item: {
      type: Object,
    },
    defaultImg: {
      type: String
    }
  },
  computed: {
    isPadding(){
      const {
        oneGroupBorder,
        oneGroupBorderShadow,
        oneGroupImageLeft
      } =  this.specialStyle;
      const {
        includeItemsImageOrVideo
      } = this.specialData;
      if((oneGroupBorder && !(oneGroupImageLeft=='1')) ||
        (oneGroupBorderShadow && !(oneGroupImageLeft=='1')) ||
        (!includeItemsImageOrVideo && (oneGroupBorder || oneGroupBorderShadow))
      ){
        return true;
      }
      return false;
    },
    imgStyle(){
      const {
        imgRadius=false,
        imgShadow=false,
        imgBorder=false,
        imgBackgroundColor='',
      } =  this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor?imgBackgroundColor:'',
        borderRadius: imgRadius?'4px':'0',
        boxShadow: imgShadow?'0px 0px 8px 0px rgba(0, 0, 0, 0.1)':'',
        border: imgBorder?`1px solid #D6DEEA`:'none',
      }
    },
    // rightStyle(){
    //   const {
    //     oneGroupBorder,
    //   } =  this.specialStyle;
    //   return {
    //     padding: oneGroupBorder?'12px':'12px 0',
    //   }
    // },
    itemStyle(){
      const {
        oneGroupBorder,
        oneGroupBGColor,
        oneGroupBorderRadius=false,
        oneGroupBorderShadow,
      } =  this.specialStyle;
      return {
        border: oneGroupBorder?'1px solid #D6DEEA':'none',
        backgroundColor: oneGroupBGColor?oneGroupBGColor:'none',
        boxShadow: oneGroupBorderShadow?'0px 0px 8px 0px rgba(0, 0, 0, 0.1)':'none',
        borderRadius: oneGroupBorderRadius? '4px':'0',
        // marginBottom:topBottomInterval+'px'

      }
    },
    titleStyle(){
      const {
        titleSize,
        titleColor='#333',
        titleBold=false,
        titleAlign,
        titleLineHeight
      } =  this.specialStyle;
      return {
        fontSize: `${titleSize}px`,
        color: titleColor,
        fontWeight: `${titleBold?'bold':''}`,
        textAlign: titleAlign?titleAlign:'center',
        marginTop:  this.specialData.includeItemsImageOrVideo? '12px': '',
        lineHeight: titleLineHeight ? titleLineHeight: ''
      }
    },
    summaryStyle(){
      const {
        descSize,
        descColor,
        descBold=false,
        descAlign,
        descLineHeight
      } =  this.specialStyle;
      return {
        fontSize: `${descSize}px`,
        color: `${descColor?descColor:'#666'}`,
        fontWeight: `${descBold?'bold':''}`,
        textAlign: descAlign?descAlign:'center',
        lineHeight: descLineHeight ? descLineHeight : ''
      }
    }
  },
  methods: {

  },
  created(){
    console.log('----->我是第四个',this.item)

  },
  mounted(){
    this.$nextTick(async()=>{
      if(this.item.publishTime){
        this.publishItem=this.item.publishTime.substring(0,10)
      }
      changeImgSizeFn(this.item.entryImg, this.$refs.picture, this.isPadding?300:338)
    })
  }

}
</script>
<style lang="less" scoped>
.graphic-one-updown{
  margin-bottom: 24px;
  box-sizing: border-box;
  width: 340px;
  &:nth-child(2n+1){
    margin-right: 22px;
  }
  &.graphic-item-padding{
    padding: 20px;
    .left-pic{
      width: 296px;
    }
    .right-cont{
      padding: 0;
      &.is-pad{
        padding: 0;
      }
    }
  }
  .left-pic{
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    width: 336px;
    // height: 252px;
    // .picture{
    //   width: 100%;
    //   height: 252px;
    // }
    .play-btn{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 80px;
      height: 80px;
    }
  }
  .right-cont {
    &.is-pad{
      padding: 0 20px 20px;
    }
    .graphic-title{
      // height: 44px;
      font-size: 32px;
      font-weight: 400;
      color: #333333;
      line-height: 44px;
    }
    .summary{
      margin-top: 12px;
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
      white-space: normal;
    }
    .create-time{
      height: 36px;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
      margin-top: 12px;
    }
    .bottomV{
      display: flex;
      align-items: center;
      margin-top: 7px;
      font-size: 24px;
    }

    .seeNum {
      width: 24px;
      margin-right: 10px;


    }
  }
}
</style>
